import * as types from 'constants/ActionTypes';
import { CAR_CONFIGURATOR } from 'constants/FeatureConstants';
import { GET_MODAL_DEALERS_SUCCESS, GET_PAGINATED_DEALERS_FETCH_SUCCESS } from 'modules/dealers/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import { changeDealerStatusSuccessReducer } from '../../utils/DealersReducersUtils';
import { mergeByFeatures } from '../extensions/utils';

// Contains all dealer ids that have been fetched so far for the CAR CONFIGURATOR feature
const initialState = [];

const initialStateReducer = () => initialState;

const fetchDealersSuccessReducer = (state, { payload }) => mergeByFeatures(state, payload.content, CAR_CONFIGURATOR);

const fetchDealerSuccessReducer = (state, { payload: dealer }) =>
  fetchDealersSuccessReducer(state, { payload: { content: [dealer] } });

export default createReducer(initialState, {
  [GET_MODAL_DEALERS_SUCCESS]: fetchDealersSuccessReducer,
  [GET_PAGINATED_DEALERS_FETCH_SUCCESS]: fetchDealersSuccessReducer,
  [types.FETCH_DEALER_SUCCESS]: fetchDealerSuccessReducer,
  [types.FETCH_DEALERS_SELECT_FAILURE]: initialStateReducer,
  [types.FETCH_DEALERS_SELECT_SUCCESS]: fetchDealersSuccessReducer,
  [types.CHANGE_DEALER_STATUS_SUCCESS]: changeDealerStatusSuccessReducer,
});
